import * as React from 'react'
import { useInView } from '../../../../utils/hooks/hooks/useInView'
import { Link } from '../../../../utils/links'
import { linkGridBlockClasses } from '../../../../utils/style'
import { getClassName, htmlDecode } from '../../../../utils/utils'
import { InviewProps } from '../blocksState'
import { LinkGridBlockStyle } from '../linkGridBlockLayout'

export type ChildDossiersItemProps = {
  slug: string
  title: string
}

export type ChildDossiersBlockProps = {
  index: number
  inview?: InviewProps
  title?: React.ReactNode
  children: ChildDossiersItemProps[]
}

export function ChildDossiersBlockLayout(props: ChildDossiersBlockProps) {
  const { inview, index, title } = props;
  const classes = linkGridBlockClasses(false);
  const { inView, ref } = useInView(
    { threshold: 0.1 },
    (inview) => console.debug("ChildDossiersBlockLayout inView:", inview),
    !inview?.triggerOnce
  )
  const inviewClassName = getClassName(classes, 'blockClassName', 'container') + ' ' + (inView ? getClassName(classes, 'inviewClassName', 'inview') : '')
  return props.children.length > 0 ? (
    <section key={`block-${index}`} id={`io-${index}`} ref={ref} className={inviewClassName}>
      <div className={getClassName(classes, 'innerClassName', 'py-5')}>
        {title && (
          <header
            className={getClassName(classes, 'headerClassName', 'text-center')}
          >
            <h2
              className={getClassName(classes, 'titleClassName', 'mb-3')}
              id={`${index}`}
            >
              {title}
            </h2>
          </header>
        )}

        <div className={getClassName(classes, 'contentClassName', '')}>
          <ul
            className={getClassName(
              classes,
              'listClassName',
              'row list-unstyled mb-0'
            )}
          >
            {props.children.map((item, i) => (
              <li
                key={`grid-${index}-${i}`}
                className={getClassName(
                  classes,
                  'gridItemClassName',
                  'col-md-6 col-lg-4 py-3'
                )}
              >
                <article
                  className={getClassName(
                    classes,
                    'gridArticleClassName',
                    ''
                  )}
                >
                  <Link
                    url={item.slug}
                    title={item.title}
                    className={getClassName(
                      classes,
                      'gridWithLinkClassName',
                      'd-flex flex-column-reverse text-secondary'
                    )}
                  >
                    <ChildDossiersItemLayout
                      title={item.title}
                      slug={item.slug}
                      key={item.slug}
                      classes={classes}
                    />
                  </Link>
                </article>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  ) : null
}

const ChildDossiersItemLayout = (
  props: ChildDossiersItemProps & {
    classes: LinkGridBlockStyle
  }
) => {
  const {
    title,
    classes,
    slug
  } = props
  return (
    <>
      {(title || slug) && (
        <div
          className={getClassName(
            classes,
            'gridContentClassName',
            'card-body px-0 pb-0'
          )}
        >
          {title && (
            <header
              className={getClassName(classes, 'gridHeaderClassName', '')}
            >
              {title && (
                <h3
                  className={getClassName(
                    classes,
                    'gridTitleClassName',
                    'mb-2'
                  )}
                >
                  {htmlDecode(title)}
                </h3>
              )}
            </header>
          )}
        </div>
      )}
    </>
  )
}
